import { render, staticRenderFns } from "./selecttaxdescription.vue?vue&type=template&id=6c145ab2&"
import script from "./selecttaxdescription.js?vue&type=script&lang=js&"
export * from "./selecttaxdescription.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c145ab2')) {
      api.createRecord('6c145ab2', component.options)
    } else {
      api.reload('6c145ab2', component.options)
    }
    module.hot.accept("./selecttaxdescription.vue?vue&type=template&id=6c145ab2&", function () {
      api.rerender('6c145ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/inputs/selecttaxdescription.vue"
export default component.exports